import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import GuideContent from './components/GuideContent';
import Footer from '../home/components/Footer';

export default function GuidePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <GuideContent />
      <Footer />
    </div>
  );
}
